module.exports = __webpack_public_path__ + "img/ClarkeR.c97f89d5.jpg";